import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import './AboutUs.css';
import axios from 'axios';

const AboutUs = () => {
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    document.title = "About Us - StreamPlay Network";

    const fetchMetaTags = async () => {
      try {
        const res = await axios.get( `${process.env.REACT_APP_BASE_URL}website/metaTags/about_us`, {
          headers: {
            Accept: 'application/json',
            'Client-Domain': process.env.REACT_APP_CLIENT_DOMAIN,
          },
        });

        const htmlString = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (err) {
        console.error("Error fetching meta tags for About Us:", err);
      }
    };

    fetchMetaTags();
  }, []);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>About Us - StreamPlay Network</title>
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="about-container">
        <div className="hero-section">
          <h1>About StreamPlay Network</h1>
          <p>Your go-to channel for everything gaming, streaming, tech, and next-gen play.</p>
        </div>

        <div className="mission-section">
          <h2>Our Mission</h2>
          <p>
            At <strong>StreamPlay Network</strong>, we blend entertainment and insight across gaming genres, livestream culture, play-to-earn ecosystems, and emerging tech. We don’t just cover games — we decode the future of digital fun.
          </p>
        </div>

        <div className="mission-section">
          <h2>What We Cover</h2>
          <ul>
            <li><strong>1. Play-to-Earn & Web3 Gaming:</strong> Reviews, earning strategies, NFT trends, wallet tutorials, gamer interviews.</li>
            <li><strong>2. Live Streaming & Creator Culture:</strong> Setup guides, software tips, streamer spotlights, and viral stream insights.</li>
            <li><strong>3. Esports Tournaments & Competitive Gaming:</strong> Recaps, team profiles, meta analysis, calendars, and prize highlights.</li>
            <li><strong>4. Gaming Infotainment & Fun Facts:</strong> Facts, myths, oddities, psychology, and wild in-game events.</li>
            <li><strong>5. Gadget Reviews & Tech for Gamers:</strong> Gear reviews, console comparisons, mobile accessories, and VR/AR previews.</li>
            <li><strong>6. Gaming News & Trends:</strong> Releases, platform updates, mergers, trend forecasting, and top monthly picks.</li>
            <li><strong>7. Entertainment & Experiments:</strong> Gaming dares, sketches, pranks, and hilarious player moments.</li>
            <li><strong>8. Next-Gen Games & Future Concepts:</strong> AI-generated worlds, Unreal previews, metaverse games, and developer talks.</li>
          </ul>
        </div>

        <div className="mission-section">
          <h2>Why StreamPlay Network?</h2>
          <p>
            Because the gaming world moves fast — and you deserve a platform that moves with it. Whether you're a casual gamer, a streaming pro, or a future esports legend, we bring you content that informs, inspires, and entertains.
          </p>

          <h2>Join the Movement</h2>
          <p>
            Subscribe, share, and explore. <strong>StreamPlay Network</strong> is more than a brand — it’s a digital playground.
          </p>

          <p className="closing-text">
            🎮 Stay sharp. Stay streamed. <br />
            — The <strong>StreamPlay Network</strong> Team
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
